import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function Faq() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto grid max-w-[1180px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-700">
            06 / FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
            常见问题
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            关于 91下载收录范围与查找方式的集中解答。若想了解更多分区细节，可回到上方的资源分类区块继续浏览。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-300 bg-background-50 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
              <i className="ri-question-answer-line text-lg" />
            </span>
            <p className="text-xs leading-6 text-foreground-600">
              还没找到答案？可在页面留言区提交问题，编辑整理后会补充进这里。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-300 overflow-hidden rounded-lg border border-background-300 bg-background-50">
            {faqItems.map((item, index) => {
              const open = active === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setActive(open ? -1 : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition hover:bg-background-100"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 font-heading text-sm font-bold text-accent-600">
                        Q{index + 1}
                      </span>
                      <span className="text-sm font-medium text-foreground-900 md:text-base">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-500 transition ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </button>
                  {open && (
                    <div className="px-5 pb-5 pl-[52px]">
                      <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}